export enum ApplicationStatus {
  ACCEPTED = 'ACCEPTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  REJECTED = 'REJECTED',
  REVISION_NEEDED = 'REVISION_NEEDED',
  SUSPENDED = 'SUSPENDED',
}

export const ApplicationStatusLabel: Record<ApplicationStatus, string> = {
  [ApplicationStatus.ACCEPTED]: 'تمت الموافقة',
  [ApplicationStatus.UNDER_REVIEW]: 'قيد المراجعة',
  [ApplicationStatus.REJECTED]: 'مرفوض',
  [ApplicationStatus.REVISION_NEEDED]: 'طلب تعديل',
  [ApplicationStatus.SUSPENDED]: 'معلق',
};
